import { createUseStyles } from 'react-jss';

import colors from "../../../utils/colors";






var styles = {
  cartItemContentWrapper: {
    border: "1px solid ".concat(colors.neutral[400]),
    borderRadius: '1rem',
    backgroundColor: colors.neutral.white,
    padding: '2.4rem 3.2rem',
    boxSizing: 'border-box',
    flex: '2 1 55%',
    overflowX: 'auto',
    position: 'relative',
    '@media(max-width: 1250px)': {
      flex: '0 0 60%'
    }
  },
  cartItemContentWrapperChecked: {
    padding: '2rem 1.6rem',
    borderLeft: "16px solid ".concat(colors.blue[600]),
    borderRight: "4px solid ".concat(colors.blue[600]),
    borderBottom: "4px solid ".concat(colors.blue[600]),
    borderTop: "4px solid ".concat(colors.blue[600])
  },
  productContentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '1.5rem'
  },
  header: {
    margin: '1.5rem 0 0',
    borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
    paddingBottom: '1.5rem'
  },
  productMainData: {
    flex: '1 0 35%',
    paddingRight: '2rem',
    boxSizing: 'border-box'
  },
  actionButton: {
    textTransform: 'uppercase',
    paddingLeft: 0,
    '&:not(:last-child)': {
      marginBottom: '0.4rem'
    }
  },
  ratesList: {
    marginBottom: '1.6rem',
    borderBottom: "1px solid ".concat(colors.neutral[400]),
    '&  li:last-child': {
      paddingBottom: '1.8rem'
    },
    '& span:first-child': {
      fontSize: '1.4rem'
    }
  },
  ratesAdditionalStyle: {
    borderBottom: 'none'
  },
  productTiles: {
    padding: 0,
    borderLeft: "1px solid ".concat(colors.neutral[300]),
    paddingLeft: '2rem'
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map